module.exports = __webpack_public_path__ + "img/twitter.ffb76ce5.svg";